import { render, staticRenderFns } from "./applicat.vue?vue&type=template&id=540bd4b0&scoped=true"
import script from "./applicat.vue?vue&type=script&lang=js"
export * from "./applicat.vue?vue&type=script&lang=js"
import style0 from "./applicat.vue?vue&type=style&index=0&id=540bd4b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "540bd4b0",
  null
  
)

export default component.exports